import { styled } from "styled-components";

import { ActionButtonItem, EditIcon, MapIcon } from "common/components";
import { useDispatch, useSelector } from "common/utilities/react-redux";
import { useGo } from "common/utilities/useGo";
import { useTranslate } from "common/utilities/useTranslate";
import { getMapHasUnsavedChanges } from "domains/createMapDetail/selectors";
import { activateModal } from "domains/modal/actions";
import { iconStyle } from "domains/topicDetail/components/actionButtons/iconStyle";
import { getTmEditMode } from "domains/transformationMap/selectors";

const StyledToolsIcon = styled(EditIcon)`
  width: 16px;
`;

const StyledCrossIcon = styled(MapIcon)`
  ${iconStyle}
`;

type EditActionButtonProps = { topicId: string };

export const EditActionButton = ({ topicId }: EditActionButtonProps) => {
  const dispatch = useDispatch();
  const go = useGo();
  const mapHasUnsavedChanges = useSelector(getMapHasUnsavedChanges);
  const isEditing = useSelector(getTmEditMode);
  const translate = useTranslate();

  const toggleEditor = () => {
    const route = `/create/${topicId}${isEditing ? "" : "?editing=true"}`;
    if (isEditing && mapHasUnsavedChanges)
      dispatch(activateModal({ id: "CancelMap", params: { onCancelRoute: route } }));
    else go(route);
  };

  const label = isEditing ? "app.topic.view_map" : "app.topic.actions.edit";

  return (
    <ActionButtonItem
      label={translate(label)}
      icon={isEditing ? <StyledCrossIcon /> : <StyledToolsIcon />}
      onClick={toggleEditor}
    />
  );
};
